/**
 * useReferralFrequency — ports-owned referral modal eligibility (replaces legacy
 * `useReferralModalFrequency`). 30-day AsyncStorage cooldown. Relative `data/` imports only.
 */
import { useCallback, useState } from "react"
import moment from "moment"

import { getFromStorage, setToStorage } from "../../../../data/utility/asyncStorageUtils"

const STORAGE_KEY_SHOWN = "@last_referral_modal_shown_date"
const FREQUENCY_DAYS = 30

export function useReferralFrequency() {
    const [canShowReferralModal, setCanShowReferralModal] = useState(false)

    const checkEligibility = useCallback(async () => {
        const lastShown = await getFromStorage(STORAGE_KEY_SHOWN)
        if (lastShown) {
            const daysSince = moment().diff(moment(lastShown), "days")
            if (daysSince < FREQUENCY_DAYS) {
                setCanShowReferralModal(false)
                return
            }
        }
        setCanShowReferralModal(true)
    }, [])

    const markAsShown = useCallback(async () => {
        await setToStorage(STORAGE_KEY_SHOWN, moment().toISOString())
        setCanShowReferralModal(false)
    }, [])

    return { canShowReferralModal, checkEligibility, markAsShown }
}
